import { Link, useSearchParams } from "react-router-dom";
import Header from "@/components/Header";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const [sp] = useSearchParams();
  const ref = sp.get("ref");
  return (
    <div className="min-h-screen bg-[#090D14] text-white">
      <Header />
      <div className="max-w-2xl mx-auto px-4 pt-32 pb-20 text-center">
        <div className="w-16 h-16 mx-auto rounded-full bg-red-500/20 grid place-items-center"><XCircle className="w-9 h-9 text-red-400" /></div>
        <h1 className="font-display text-4xl font-extrabold mt-6">Payment cancelled</h1>
        <p className="mt-3 text-slate-400">Ride <span className="font-mono text-amber-400">#{ref}</span> is still on hold. You can retry payment or pay the driver directly.</p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to={`/confirmation/${ref}`}><Button className="btn-gold rounded-full px-6 h-12">Try again</Button></Link>
          <Link to="/"><Button variant="outline" className="rounded-full border-white/15 bg-transparent hover:bg-white/5 text-white h-12 px-6">Home</Button></Link>
        </div>
      </div>
    </div>
  );
}
